import React, {useEffect} from 'react';
import {Col, Row} from 'reactstrap';
import {connect} from "react-redux";

// components
import TabOptionList from "./_list";
import TabOptionForm from "./_form";
import {showToastCustom} from "../../../components/toast/customToast";
import {ButtonNew, ButtonSync} from "../../../components/buttons/buttonsActions";
import {showLoader} from "../../../components/loader/loader";

// labels
import {error, success, updateMsg} from "../../../components/i18n/i18n";

// actions
import {
    clearState, setApp, setCategory,
    setLoading, setUdn, setViewMode
} from "../../../redux/actions/generalActions/mainActions";
import {clearState as clearListState} from "../../../redux/actions/generalActions/listActions";
import {setForm} from "../../../redux/actions/generalActions/formActions";

// service
import {tabOptionService} from "../../../jwt/_services/promotions/tabOptionService";
import {langTabOptionService} from "../../../jwt/_services/relations/langTabOptionService";

const TabOption = (props) => {
    const { viewMode, loading } = props.mainProps

    useEffect(() => {
        return () => {
            props.clearState();
            props.clearListState();
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);
    },[]);

    const syncFirebase = () => {
        props.setLoading(true);
        tabOptionService.syncFirebase()
            .then(_ => {
                props.setLoading(false);
            })
            .catch(errorMessage => {
                props.setLoading(false);
                showToastCustom(error, errorMessage);
            });

        langTabOptionService.syncFirebase()
            .then(_ => {
                props.setLoading(false);
                showToastCustom(success, updateMsg);
            })
            .catch(errorMessage => {
                props.setLoading(false);
                showToastCustom(error, errorMessage);
            });
    }

    const newItem = () => {
        props.setForm()
        props.setViewMode('FORM')
    }

    return (
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        {
                            viewMode === "LIST" ?
                                <div className="ml-auto paddingAdd">
                                    <ButtonSync onClick={syncFirebase}/>
                                    <ButtonNew onClick={newItem}/>
                                </div> : null
                        }
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    {(
                        function() {
                            switch (viewMode) {
                                case "LIST" :
                                    return <TabOptionList />
                                case "FORM" :
                                    return <TabOptionForm />
                                default:
                                    return null;
                            }
                        })()}
                </Col>
            </Row>
        </div>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    setUdn,
    setForm,
    setApp,
    setCategory,
    setViewMode,
    setLoading,
    clearListState
});

export default connect(mapStateToProps, mapActionsToProps)(TabOption)
